import { createAction, handleActions } from 'redux-actions';

const setShowSupplierModal = createAction("SCREENS/SUPPLIER_VIEW/SET_SHOW_SUPPLIER_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowSupplierModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowSupplierModal, reducer };
